module.exports = __webpack_public_path__ + "img/login-v2.bce692b0.svg";